/** An invitation's attention lifetime; no notification permission or service-worker involvement. */
export class CallAttention {
  private readonly base = document.title;
  private lastTitle: string | undefined;
  private timer?: ReturnType<typeof setInterval>;
  private soundTimer?: ReturnType<typeof setInterval>;
  private audio?: AudioContext;
  private stopped = false;
  constructor(private readonly title: string) {
    document.addEventListener('visibilitychange', this.visibility);
    this.visibility();
    if (typeof AudioContext !== 'undefined' && navigator.userActivation?.hasBeenActive) {
      try {
        this.audio = new AudioContext();
        const ring = () => {
          if (this.stopped || this.audio?.state !== 'running') return;
          const context = this.audio;
          for (const frequency of [440,480]) {
            const oscillator = context.createOscillator(), gain = context.createGain();
            gain.gain.setValueAtTime(.025,context.currentTime); gain.gain.exponentialRampToValueAtTime(.001,context.currentTime + .55);
            oscillator.frequency.value = frequency; oscillator.connect(gain); gain.connect(context.destination);
            oscillator.start(); oscillator.stop(context.currentTime + .6);
          }
        };
        void this.audio.resume().then(ring).catch(() => undefined);
        this.soundTimer = setInterval(ring,2500);
      } catch { /* The in-tab sheet/title remain available when audio is blocked. */ }
    }
  }
  private restore() { if (this.lastTitle !== undefined && document.title === this.lastTitle) document.title = this.base; this.lastTitle = undefined; }
  private visibility = () => {
    clearInterval(this.timer); this.restore();
    if (this.stopped || document.visibilityState !== 'hidden') return;
    this.lastTitle = this.title; document.title = this.title;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    this.timer = setInterval(() => { this.lastTitle = document.title === this.title ? this.base : this.title; document.title = this.lastTitle; },1200);
  };
  stop(): void {
    if (this.stopped) return; this.stopped = true;
    clearInterval(this.timer); clearInterval(this.soundTimer); document.removeEventListener('visibilitychange',this.visibility); this.restore();
    if (this.audio) void this.audio.close().catch(() => undefined); this.audio = undefined;
  }
}
